import React, { useState, useEffect, useRef } from "react";
import "../DashBoard/sliding.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { VRcontentReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Paper, TextField, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

//import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";

import ApplicationAccordion from "./Accordion";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";

function ListContent(props) {
  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const [deletepopUp, setdeletepopUp] = useState(false);

  //spinner for API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  // Dispatch function
  const dispatch = useDispatch();

  const content_btn = useSelector((state) => state.VRcontent.content_btn);

  let [showhide, setShowhide] = useState([]);
  const [textvalidated, settextvalidated] = useState(false);

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  //content Edit related selectors
  const content_3Did = useSelector((state) => state.VRcontent.content_3Did);
  const content_id = useSelector((state) => state.VRcontent.content_id);
  const content_name = useSelector((state) => state.VRcontent.content_name);
  const content_tag = useSelector((state) => state.VRcontent.content_tag);
  const content_fileName = useSelector(
    (state) => state.VRcontent.content_fileName
  );
  const content_format = useSelector((state) => state.VRcontent.content_format);
  const content_description = useSelector(
    (state) => state.VRcontent.content_description
  );

  const division_edit = useSelector((state) => state.VRcontent.division_edit);
  const product_edit = useSelector((state) => state.VRcontent.product_edit);
  const content_IsPane = useSelector((state) => state.VRcontent.contentIsPane);
  const addcontent_IsPane = useSelector(
    (state) => state.VRcontent.addContentIsPane
  );
  const addcontent_IsPane1 = useSelector(
    (state) => state.VRcontent.addContentIsPane1
  );

  //state hook for listcontent API's
  const [contentData, setcontentData] = useState([]);
  const [contentCount, setcontentCount] = useState(null);

  const [contentDesc, setContentDesc] = useState("");

  //const [productID, setProductID] = useState("");

  const [applicationID, setApplicationID] = useState("");

  // hook for edit content api
  const [EcontentID, setEcontentID] = useState("");
  const [EcontentName, setEcontentName] = useState("");
  const [EcontentTag, setEcontentTag] = useState("");
  const [EcontentType, setEcontentType] = useState("");
  const [EcontentFormat, setEcontentFormat] = useState("");
  const [EcontentURL, setEcontentURL] = useState("");
  const [EcontentText, setEcontentText] = useState("");
  const [EcontentDesc, setEcontentDesc] = useState("");
  const [EcontentStatus, setEcontentStatus] = useState("");
  const [EcontentFileName, setEcontentFileName] = useState("");

  const [EcontentDeleteType, setEcontentDeleteType] = useState("");

  // for 3D file Edit
  const [Econtent3Dfilename, setEcontent3Dfilename] = useState("");
  const [Econtent3DTag, setEcontent3DTag] = useState("");
  const [Econtent3DOs, setEcontent3DOs] = useState("");
  const [Econtent3Dpath, setEcontent3Dpath] = useState("");

  const [showhide1, setShowhide1] = useState("");

  const [divisionData, setdivisionData] = useState([]);

  const [viewContentTable, setViewContentTable] = useState([]);

  // filtering
  const [ContentFilter, setContentFilter] = useState("");
  const [ContentselData, setContentselData] = useState("");

  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyContentselData, setDummyContentselData] = useState("");

  const content_filterVR = useSelector(
    (state) => state.VRcontent.content_filterVR
  );
  const [editpopUp, seteditPopUp] = useState(false);
  const [edit3DpopUp, setedit3DPopUp] = useState(false);

  //Permission for Roles
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  // const Download_Permission = useSelector((state) => state.AccessTocken.Download_Permission);

  //View content update
  const bu_viewcontent = useSelector((state) => state.VRcontent.bu_viewcontent);
  const division_viewcontent = useSelector(
    (state) => state.VRcontent.division_viewcontent
  );
  const product_viewcontent = useSelector(
    (state) => state.VRcontent.product_viewcontent
  );

  //const col1_visible = useSelector((state) => state.VRcontent.col1_visible);

  const [Edit3D, setEdit3D] = useState(false);

  //Tiles or Table
  const [viewCards, setViewCards] = useState(true);

  //dummy state
  const [dub, setdub] = useState(0);

  const [accept, setAccept] = useState("");
  const [threeDcorrectFile, setThreeDcorrectFile] = useState(null);
  const [file3D, setFile3D] = useState(null);
  const [file3Dname, setFile3DName] = useState("");
  const [osType, setOsType] = useState("");
  let [acceptArr, setAcceprArr] = useState([]);
  let [content1Arr, setContent1Arr] = useState([]);

  //File or URL
  let [fileRurl, setFileRUrl] = useState([]);

  //3D file submit status
  const [api3DStatus, setApi3DStatus] = useState("");

  //File Format
  let [fileType, setFileType] = useState([]);

  //File Upladd status
  const [apiAddStatus, setApiAddStatus] = useState([]);
  const [apiAddStatusMap, setApiAddStatusMap] = useState([]);
  const [failMsg, setFailMsg] = useState([]);
  const [existMsg, setExistMsg] = useState([]);
  const [successMsg, setSuccessMsg] = useState([]);
  const [failDisable, setFailDisble] = useState(false);
  const [successCountState, setSuccessCountState] = useState(0);
  const [existCountState, setExistCountState] = useState(0);
  const [failCountState, setFailCountState] = useState(0);
  let [formValueThere, setFormValueThere] = useState(0);

  let failCount = 0;
  let existCount = 0;
  let successCount = 0;

  //Show By
  const [showBy, setShowBy] = useState("All content");

  let [formValues, setFormvalues] = useState([]);

  // Form data
  let [CTag, setCTag] = useState([]);
  let [CName, setCName] = useState([]);
  let [CType, setCType] = useState([]);
  let [CMin, setCMin] = useState([]);
  let [CSec, setCSec] = useState([]);
  let [CFormat, setCFormat] = useState([]);
  let [CDescription, setCDescription] = useState([]);
  let [CStatus, setCStatus] = useState([]);
  let [CUrl, setCUrl] = useState([]);
  let [CText, setCText] = useState([]);
  let [TDCFileName, setTDCFileName] = useState([]);
  let [TDCosType, setTDCosType] = useState([]);

  //View content
  const [viewContentPopUp, setViewContentPopUp] = useState(false);
  const [contentPopUpType, setContentPopUpType] = useState("");
  const [contentPopUpFormat, setContentPopUpFormat] = useState("");
  const [contentPopUpSrc, setContentPopUpSrc] = useState("");
  const defaultUrl = "Image Cannot be dispalyed!";
  const [colvisible, setcolvisible] = useState(false);
  const editdisable = false;
  const [viewContentPopUpDetails, setViewContentPopUpDetails] = useState([]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    height: 300,
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    padding: "15px",
  };

  const viewContentPopUpStyle = {
    position: "absolute",
    backgroundColor: "white",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95vw",
    // overflowY: "auto",
    height: "95vh",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  const viewContentFunction = async (item) => {
    if (item.te_contenttype !== "text") {
      const resp = await fetch(item.te_contenturl, options);
      const b = await resp.blob();
      const url = URL.createObjectURL(b);
      setContentPopUpSrc(url);
    } else {
      setContentPopUpSrc(item.te_contenttext);
    }

    setViewContentPopUp(true);
    setContentPopUpType(item.te_contenttype);
    setContentPopUpFormat(item.te_contentformat);
    setViewContentPopUpDetails(item);
    // setViewContentPopUp(true);
    // setContentPopUpType(item.te_contenttype);
    // setContentPopUpFormat(item.te_contentformat);
    // setViewContentPopUpDetails(item);

    // item.te_contenttype === "text"
    //   ? setContentPopUpSrc(item.te_contenttext)
    //   : setContentPopUpSrc(item.te_contenturl);
  };

  let handleChangeTrial = (i, e) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormvalues(newFormValues);
    // console.log(formValues);
  };

  const [addExtra, setaddExtra] = useState(false);
  const [add3DContent, setadd3DContent] = useState(false);
  const [add3DContentfiles, setadd3DContentfiles] = useState(false);
  const [ApplicationResponse, setApplicationResponse] = useState([]);

  const ref = useRef();

  let addFormFields = () => {
    let newForm = new FormData();
    setFormvalues([...formValues, newForm]);
    setFileType([...fileType, []]);

    //Form values
    setCTag([...CTag, ""]);
    setCName([...CName, ""]);
    setCType([...CType, ""]);
    setCMin([...CMin, ""]);
    setCSec([...CSec, ""]);
    setCFormat([...CFormat, ""]);
    setCDescription([...CDescription, ""]);
    setCStatus([...CStatus, ""]);
    setCUrl([...CUrl, ""]);
    setCText([...CText, ""]);
    setTDCFileName([...TDCFileName, ""]);
    setTDCosType([...TDCosType, ""]);

    //File or URL
    setFileRUrl([...fileRurl, ""]);

    //enable or disable duration and file format
    setShowhide([...showhide, ""]);

    //FormValueCount
    setFormValueThere((val) => val + 1);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormvalues(newFormValues);
    let newFileType = [...fileType];
    newFileType.splice(i, 1);
    setFileType(newFileType);
    fileRurl.splice(i, 1);
    showhide.splice(i, 1);

    //FormValues Remove
    CTag.splice(i, 1);
    CName.splice(i, 1);
    CType.splice(i, 1);
    CMin.splice(i, 1);
    CSec.splice(i, 1);
    CFormat.splice(i, 1);
    CDescription.splice(i, 1);
    CStatus.splice(i, 1);
    CUrl.splice(i, 1);
    CText.splice(i, 1);

    //FormValueCount
    setFormValueThere((val) => val - 1);
  };

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const responseData = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`vrcontent/list/?page=1&limit=${listLimit}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          let contentLength =
            response.data.data.threedresults[0].count +
            response.data.data.contentresults[0].count;
          let pages;
          contentLength === 0
            ? (pages = 1)
            : (pages = Math.ceil(contentLength / listLimit));

          setcontentCount(
            response.data.data.threedresults[0].count +
              response.data.data.contentresults[0].count
          );
          setNoOfPages(pages);

          const Array1 = response.data.data.contentresults[0].rows;

          const Array2 = response.data.data.threedresults[0].rows;

          for (let i = 0; i < Array1.length; i++) {
            Array1[i].Content3DType = "false";
          }

          for (let i = 0; i < Array2.length; i++) {
            Array2[i].Content3DType = "true";
          }
          const TotalArray = [...Array1, ...Array2];
          return setcontentData(TotalArray);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));

        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });

    await axios
      .get(`businessunit/listactive`, options)
      .then((resp) => {
        if (resp.status === 200) {
          setBuData(resp.data.data);
          dispatch(sidebarReducer.apiLoad(false));
        } else if (resp.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));

        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });

    await axios
      .get(`getvrcontentsbyapplication/list`, options)
      .then((appResp) => {
        // if (appResp.status === 200) {

        const appArr = appResp.data.Applications;

        dispatch(sidebarReducer.apiLoad(false));
        setApplicationResponse(appArr);

        // }
        // else if (appResp.status !== 200) {
        //   dispatch(sidebarReducer.apiLoad(false));
        //   dispatch(sidebarReducer.stringUpdate("AppDown"));
        // }
      });
    // .catch((err) => {
    //   dispatch(sidebarReducer.apiLoad(false));
    //   dispatch(sidebarReducer.stringUpdate("AppDown"));
    // });
  };

  const [contentForm, setContentForm] = useState("");

  const img = ["gif", "jpeg", "jpg", "png"];
  const vid = ["mp4", "avi", "mov"];
  const aud = ["mp3", "mpeg"];
  const docs = ["pdf", "docx", "txt", "odt"];

  const [mapper, setMapper] = useState([]);

  // eslint-disable-next-line
  let mapIndex = 0;
  //Add content API
  const handleMapping = (e) => {
    let val = e;
    mapIndex = val;

    switch (val) {
      case "image":
        setEcontentType("image");
        setMapper(mapper);
        setMapper(img);
        break;
      case "audio":
        setMapper(aud);
        setEcontentType("audio");
        break;
      case "video":
        setMapper(vid);
        setEcontentType("video");
        break;
      case "file":
        setMapper(docs);
        setEcontentType("application");
        break;
      default:
        break;
    }
  };

  const [buData, setBuData] = useState([]);

  async function DivData(opt) {
    const response = await axios.get(`division/listactive/${opt}`, options);
    return setdivisionData(response.data.data);
  }

  const [applicationData, setApplicationData] = useState([]);

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, ContentselData, ContentFilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, ContentselData, ContentFilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, ContentselData, ContentFilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, ContentselData, ContentFilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      setPageSelected(pageNo);
      setcontentData([]);
      dispatch(sidebarReducer.apiLoad(true));
      await axios
        .get(`vrcontent/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            const Array1 = response.data.data.contentresults[0].rows;

            const Array2 = response.data.data.threedresults[0].rows;

            for (let i = 0; i < Array1.length; i++) {
              Array1[i].Content3DType = "false";
            }

            for (let i = 0; i < Array2.length; i++) {
              Array2[i].Content3DType = "true";
            }
            const TotalArray = [...Array1, ...Array2];
            setcontentData(TotalArray);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);
      dispatch(sidebarReducer.apiLoad(true));
      if (!isFilterIReset) {
        await axios
          .get(
            `vrcontent/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              const Array1 = response.data.data.contentresults[0].rows;

              const Array2 = response.data.data.threedresults[0].rows;

              for (let i = 0; i < Array1.length; i++) {
                Array1[i].Content3DType = "false";
              }

              for (let i = 0; i < Array2.length; i++) {
                Array2[i].Content3DType = "true";
              }
              const TotalArray = [...Array1, ...Array2];
              setcontentData(TotalArray);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        await axios
          .get(
            `vrcontent/list/?page=${pageNo}&limit=${listLimit}&${dummyContentselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              const Array1 = response.data.data.contentresults[0].rows;

              const Array2 = response.data.data.threedresults[0].rows;

              for (let i = 0; i < Array1.length; i++) {
                Array1[i].Content3DType = "false";
              }

              for (let i = 0; i < Array2.length; i++) {
                Array2[i].Content3DType = "true";
              }
              const TotalArray = [...Array1, ...Array2];
              setcontentData(TotalArray);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };

  async function fetchApplicationID(val) {
    await axios
      .get(`vr_applications/active/${val}`, options)
      .then((response) => setApplicationData(response.data.data.rows));
    // .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")));
  }

  //Update content API
  let NewFormData = new FormData();

  const onUpdate = async (content_id) => {
    NewFormData.set("teContentTag", EcontentTag);
    NewFormData.set("teContentName", EcontentName);
    NewFormData.set("teContentType", EcontentType);
    NewFormData.set("teContentFileName", EcontentFileName);
    NewFormData.set("teContentDescription", EcontentDesc);
    NewFormData.set("teAppId", applicationID);
    NewFormData.set("teContentStatus", EcontentStatus); // if(EcontentType ===)
    EcontentType === "text"
      ? NewFormData.set("teContentText", EcontentText)
      : NewFormData.set("teContentUrl", EcontentURL);
    // dispatch(sidebarReducer.apiLoad(true));

    axios
      .put(`vrcontent/update/${content_id}`, NewFormData, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.update_success(true));
          tableupdate(applicationID);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
        // console.log(response);
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.update_failure(true));
        dispatch(sidebarReducer.update_success(false));
      });
  };

  let editForm3D = new FormData();

  //3d update function
  const on3DUpdate = async (content_id) => {
    // console.log("productID", item);
    editForm3D.set("ostype", Econtent3DOs);
    editForm3D.set("teContentFileName", Econtent3Dfilename);
    editForm3D.set("threeDContentId", content_id);
    editForm3D.set("teAppId", applicationID);
    editForm3D.set("status", "1");
    editForm3D.set("teContentTag", Econtent3DTag);
    editForm3D.set("filepath", Econtent3Dpath);
    // console.log("editform", editForm3D);

    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`vr_threedcontent/update/${content_id}`, editForm3D, options)
      .then((response) => {
        // console.log("eee", editForm3D);
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.update_success(true));
          console.log(file3Dname);
          setFile3DName(Econtent3Dfilename);
          setOsType(Econtent3DOs);
          responseData();
          tableupdate(applicationID);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => dispatch(sidebarReducer.stringUpdate("AppDown")));
  };

  const tableupdate = async (applicationID) => {
    dispatch(sidebarReducer.apiLoad(true));

    await axios
      .get(`vrcontent/list/${applicationID}`, options)
      .then((response) => {
        dispatch(sidebarReducer.apiLoad(false));
        const tableUpdateArr1 = response.data.data.contentresults[0].rows;
        const tableUpdateArr2 = response.data.data.threedresults[0].rows;

        for (let i = 0; i < tableUpdateArr1.length; i++) {
          tableUpdateArr1[i].Content3DType = "false";
        }

        for (let i = 0; i < tableUpdateArr2.length; i++) {
          tableUpdateArr2[i].Content3DType = "true";
        }

        const TotalArraytableUpdate = [...tableUpdateArr1, ...tableUpdateArr2];

        setViewContentTable(TotalArraytableUpdate);

        dispatch(VRcontentReducer.content_btn(true));
        responseData();
      })
      .catch((err) => dispatch(sidebarReducer.apiLoad(false)));

    await axios
      .get(`vr_threedcontent/findByVrAppId/${applicationID}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          let res = [response.data.data];
          res.map((item, index) => {
            setFile3DName(item.te_filename);
            setOsType(osType); //VVV
            setOsType(item.te_ostype);
            dispatch(VRcontentReducer.content_3Did(item.te_3dmodelcontentid));
            return null;
          });
          if (
            response.data.message ===
            "3DCONTENT BY APPLICATIONID FOUND SUCCESSFULLY"
          ) {
            // setaddExtra(true);
            // setadd3DContent(false);
            console.log(add3DContent, add3DContentfiles);
            // setadd3DContentfiles(false);
          } else if (response.data.message === "NO APPLICATIONID FOUND") {
            // setadd3DContent(true);
            // setaddExtra(false);
          }
        }
      })
      .catch((err) => dispatch(sidebarReducer.apiLoad(false)));
  };

  //3D Content
  let threeDFormData = new FormData();

  const change3DFile = (e) => {
    let val = e.target.files[0];
    let type = val.type;
    if (type === "") {
      setThreeDcorrectFile(false);
      setFile3D(val);
    } else {
      setThreeDcorrectFile(true);
    }
    // setfilevalidated(val);

    threeDFormData.append("file", file3D);
  };

  async function onSubmit3D(e) {
    //Please do not change this code. This function deals with submiting the content while adding.
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));

    if (apiAddStatus.length > 0) {
      for (let i = 0; i < apiAddStatus.length; i++) {
        apiAddStatus[i] = "L";
        apiAddStatusMap[i] = "L";
      }
    }

    await Promise.all(
      formValues.map(async (item, i) => {
        let val =
          formValues[i].get("teContentmin") + formValues[i].get("teContentsec");
        apiAddStatus[i] = "L";
        apiAddStatusMap[i] = "L";

        setContent1Arr(apiAddStatus);
        // console.log(apiAddStatus, "Laod");
        formValues[i].set("index", i);
        formValues[i].set("teAppId", applicationID);
        // formValues[i].set("teContentDescription", contentDesc);
        formValues[i].set("teContentDuration", val);

        await axios
          .post(
            formValues[i].get("teContentType") === "3d_content"
              ? `vr_threedcontent/add`
              : `vrcontent/create`,
            item,
            options
          )
          .then((res) => {
            // console.log(res.message);
            // console.log(res.status, i);
            if (res.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              if (res.data.message === "CONTENT ADDED SUCCESSFULLY") {
                responseData();
                apiAddStatus[i] = "S";
                apiAddStatusMap[i] = "S";

                successCount++;
              } else if (
                res.data.message ===
                "URL is not valid!, please provide a valid URL."
              ) {
                apiAddStatus[i] = "F";
                apiAddStatusMap[i] = "F";

                failCount++;
              } else {
                apiAddStatus[i] = "FE";
                apiAddStatusMap[i] = "FE";

                existCount++;
              }
            }
            setContent1Arr(apiAddStatus);
          })
          .catch((AxiosError) => {
            if (AxiosError.response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              apiAddStatus[i] = "F";
              apiAddStatusMap[i] = "F";

              failCount++;
            }
            setContent1Arr(apiAddStatus);
          });
      })
    );

    if (addExtra) {
      if (
        (successCount + failCount + existCount === 1 && formValueThere === 0) ||
        successCount + failCount + existCount === formValueThere + 1
      ) {
        setPopUp(true);
      }
    } else if (!addExtra) {
      if (successCount + failCount + existCount === formValueThere) {
        setPopUp(true);
      }
    }

    setSuccessCountState(successCount);
    setExistCountState(existCount);
    setFailCountState(failCount);

    //check the fail case and send the pop up.
    if (failCount > 0) {
      setFailMsg(
        `${failCount} ${
          failCount > 1 ? "Contents" : "Content"
        } failed, Please try again!`
      );
    }

    //check the exist case and send the pop up.
    if (existCount > 0) {
      setExistMsg(
        `${existCount} ${
          existCount > 1 ? "Contents" : "Content"
        } already existed.`
      );
    }

    //check the success message case.
    if (addExtra === true) {
      if (successCount === 1 && formValueThere === 0) {
        setSuccessMsg("Content added successfully!");
      } else if (successCount === formValueThere + 1) {
        setSuccessMsg("Content added successfully!");
      }
    } else if (addExtra === false) {
      if (successCount === formValueThere) {
        setSuccessMsg("Content added successfully!");
      } else if (successCount > 0 && successCount < formValueThere) {
        setSuccessMsg(
          `${successCount} ${
            successCount > 1 ? "Contents" : "Content"
          } added successfully!`
        );
      }
    } else if (successCount === 0) {
      setSuccessMsg("");
    } else if (successCountState === 0) {
      setSuccessMsg("");
    }
  }

  // Reset the data after conetnt added successfully or not added successfully.
  const resetAddContent = () => {
    setPopUp(false);
    dispatch(VRcontentReducer.addContent_IsPane(false));
    dispatch(VRcontentReducer.division_edit(false));
    dispatch(VRcontentReducer.product_edit(false));
    dispatch(VRcontentReducer.content_btn(false));
    setFormvalues([]);
    setContentFilter("");
    setContentselData("");
    setaddExtra(false);
    setThreeDcorrectFile(null);
    setApi3DStatus("");
    setContent1Arr([]);
    setAcceprArr([]);
    setFileType([]);
    setFileRUrl([]);
    setMapper([]);
    existCount = 0;
    failCount = 0;
    successCount = 0;
    setSuccessMsg("");
    setApiAddStatus([]);
    setFile3D(null);
    setFailMsg("");
    setExistMsg("");
    setFailDisble(false);
    setFormValueThere(0);
    setEcontentText("");
    setEdit3D(false);
    console.log(Edit3D,);

    setApiAddStatusMap([]);
    setCTag([]);
    setCName([]);
    setCType([]);
    setCMin([]);
    setCSec([]);
    setCFormat([]);
    setCDescription([]);
    setCStatus([]);
    setCUrl([]);
    setCText([]);
    setTDCFileName([]);
    setTDCosType([]);
    // responseData();
  };

  const resetAddContent1 = () => {
    setPopUp(false);
    dispatch(VRcontentReducer.addContent_IsPane1(false));
    dispatch(VRcontentReducer.division_edit(false));
    dispatch(VRcontentReducer.product_edit(false));
    dispatch(VRcontentReducer.content_btn(false));
    setFormvalues([]);
    setContentFilter("");
    setContentselData("");
    setaddExtra(false);
    setThreeDcorrectFile(null);
    setApi3DStatus("");
    setContent1Arr([]);
    setAcceprArr([]);
    setFileType([]);
    setFileRUrl([]);
    setMapper([]);
    existCount = 0;
    failCount = 0;
    successCount = 0;
    setSuccessMsg("");
    setApiAddStatus([]);
    setFile3D(null);
    setFailMsg("");
    setExistMsg("");
    setFailDisble(false);
    setFormValueThere(0);

    setCTag([]);
    setCName([]);
    setCType([]);
    setCMin([]);
    setCSec([]);
    setCFormat([]);
    setCDescription([]);
    setCStatus([]);
    setCUrl([]);
    setCText([]);
    setTDCFileName([]);
    setTDCosType([]);
    // responseData();
  };

  // When content got failed
  const failAddCase = () => {
    setPopUp(false);
    existCount = 0;
    failCount = 0;
    successCount = 0;
    setExistCountState(0);
    setFailCountState(0);
    setSuccessCountState(0);
    setSuccessMsg("");
    setFailMsg("");
    setExistMsg("");
    if (addExtra && api3DStatus === "F") {
      setApi3DStatus("");
    } else {
      setaddExtra(false);
    }

    for (let i = 0; i < apiAddStatusMap.length; i++) {
      if (apiAddStatusMap[i] === "S" || apiAddStatusMap[i] === "FE") {
        formValues.splice(i, 1);
        fileType.splice(i, 1);
        fileRurl.splice(i, 1);
        showhide.splice(i, 1);
        apiAddStatus.splice(i, 1);

        //FormValues Remove
        CTag.splice(i, 1);
        CName.splice(i, 1);
        CType.splice(i, 1);
        CMin.splice(i, 1);
        CSec.splice(i, 1);
        CFormat.splice(i, 1);
        CDescription.splice(i, 1);
        CStatus.splice(i, 1);
        CUrl.splice(i, 1);
        CText.splice(i, 1);
        TDCFileName.splice(i, 1);
        TDCosType.splice(i, 1);
      }
      if (i === apiAddStatusMap.length - 1) {
        setFormValueThere((num) => (num = apiAddStatus.length));
      }
    }
    // setFailDisble(true);
  };

  //Select a user from the table to get the pop up
  async function on3DEdit(item) {
    await axios
      .get(`vr_threedcontent/list/${item.te_3dmodelcontentid}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          const resp = response.data.data.rows[0];

          setEcontent3Dfilename(resp.te_filename);
          setEcontent3DOs(resp.te_ostype);
          setEcontent3Dpath(resp.te_filepath);
          setEcontent3DTag(resp.te_contenttag);

          dispatch(VRcontentReducer.content_3DfileName(resp.te_filename));
          dispatch(VRcontentReducer.content_3Dos(resp.te_ostype));
          dispatch(VRcontentReducer.content_id(resp.te_3dmodelcontentid));
          dispatch(VRcontentReducer.content_3DTag(resp.te_contenttag));
          dispatch(
            VRcontentReducer.content_applicationID(resp.te_application_id)
          );
        } else if (response.status !== 200) {
          // dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        // dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  async function onEdit(item) {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`vrcontent/details/${item.te_contentid}`, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          setEcontentName(item.te_contentname);
          setEcontentTag(item.te_contenttag);
          setEcontentType(item.te_contenttype);
          setEcontentFormat(item.te_contentformat);
          setEcontentURL(item.te_contenturl);

          setEcontentDesc(item.te_contentdescription);

          setEcontentStatus(item.te_contentstatus);

          setEcontentFileName(item.te_contentname);

          dispatch(VRcontentReducer.content_id(item.te_contentid));
          dispatch(VRcontentReducer.content_name(item.te_contentname));
          dispatch(VRcontentReducer.content_tag(item.te_contenttag));
          dispatch(VRcontentReducer.content_fileName(item.te_contentfilename));
          dispatch(VRcontentReducer.content_status(item.te_contentstatus));
          dispatch(VRcontentReducer.content_type(item.te_contenttype));
          dispatch(
            VRcontentReducer.content_applicationID(item.te_application_id)
          );
          dispatch(VRcontentReducer.content_format(item.te_contentformat));
          dispatch(
            VRcontentReducer.content_description(item.te_contentdescription)
          );
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  const onCancel = () => {
    setEcontentID(content_id);
    setEcontentName(content_name);
    setEcontentTag(content_tag);
    setEcontentDesc(content_description);
    setEcontentFileName(content_fileName);
    setEcontentFormat(content_format);
    seteditPopUp(false);
    setedit3DPopUp(false);

    setEcontent3Dfilename("");
    setEcontent3DOs("");
    setEcontent3DTag("");
  };

  const onDelete = async (id) => {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .delete(
        EcontentDeleteType === "Content"
          ? `vrcontent/delete/${id}`
          : `vr_threedcontent/delete/${id}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          setdeletepopUp(false);
          dispatch(sidebarReducer.delete_success(true));
          tableupdate(applicationID);

          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.delete_success(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });

    // .catch((err) => {
    //   // dispatch(sidebarReducer.apiLoad(false));
    //   dispatch(sidebarReducer.delete_success(false));
    //   dispatch(sidebarReducer.stringUpdate("AppDown"));
    // });

    // await axios
    //   .delete(`vr_threedcontent/delete/${id}`, options)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       // dispatch(sidebarReducer.apiLoad(false));
    //       setdeletepopUp(false);
    //       dispatch(sidebarReducer.delete_success(true));
    //       tableupdate(applicationID);
    //       responseData();
    //     } else if (response.status !== 200) {
    //       dispatch(sidebarReducer.stringUpdate("AppDown"));
    //     }
    //   })
  };

  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // for filtering
  const handleSearch = (e, ContentselData, keyWord) => {
    if (showBy !== "Application") {
      api(e, ContentselData, keyWord);
    } else {
      appFilter(ContentselData, keyWord);
    }
  };

  const appFilter = (ContentselData, keyWord) => {
    let apiResp = ApplicationResponse;
    let word = keyWord.toLowerCase();
    let newResp;
    if (ContentselData === "te_buname") {
      newResp = apiResp.filter((data) => {
        let bu = data.division.business_unit.te_buname.toLowerCase();
        return bu === word;
      });
    } else if (ContentselData === "te_divisionname") {
      newResp = apiResp.filter((data) => {
        let div = data.division.te_divisionname.toLowerCase();
        return div === word;
      });
    } else if (ContentselData === "te_application_name") {
      newResp = apiResp.filter((data) => {
        let app = data.applicationName.toLowerCase();
        return app === word;
      });
    }
    setApplicationResponse(newResp);
  };

  const api = async (e, ContentselData, keyWord) => {
    e.preventDefault();

    dispatch(sidebarReducer.apiLoad(true));

    await axios
      .get(`vrcontent/list?limit=20&${ContentselData}=${keyWord}`, options)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          // const Array = resp.data.data.rows.filter((item) => {
          //   return item.te_isdeleted === "0";
          // });
          const Array1 = resp.data.data.contentresults[0].rows;

          const Array2 = resp.data.data.threedresults[0].rows;

          const TotalArray = [...Array1, ...Array2];

          setcontentData(TotalArray);
          setcontentCount(
            resp.data.data.threedresults[0].count +
              resp.data.data.contentresults[0].count
          );

          let contentLength =
            resp.data.data.threedresults[0].count +
            resp.data.data.contentresults[0].count;
          let pages;
          contentLength === 0
            ? (pages = 1)
            : (pages = Math.ceil(contentLength / listLimit));

          console.log(pages);
          setNoOfPages(pages);

          dispatch(VRcontentReducer.content_filterVR(false));
        } else if (resp.status !== 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          // dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        // dispatch(sidebarReducer.apiLoad(false));
        console.log(err);
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const handleReset = () => {
    dispatch(VRcontentReducer.content_filterVR(true));
    responseData();
    setContentFilter("");
    setContentselData("");
    // setDummyContentFilter("");
    setDummyContentselData("");
    setIsFilterIReset(false);
  };

  const handleReset1 = (e) => {
    setContentFilter("");
    setContentselData("");
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className={`${viewCards ? "Immage" : null} container-fluid`}>
          {/** total content part in the layout */}
          <div className="row">
            {/** ROW 1 for header */}
            <div className="col-12 p-0" style={{ minHeight: "84.6vh" }}>
              <div className="row g-0 p-0">
                <div className="col">
                  <div
                    className=" g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-3" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>VR_Content</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-9">
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            {viewCards && showBy !== "Application" && (
                              <button
                                className="btn"
                                // data-bs-toggle="collapse"
                                // data-bs-target="#collapseOne"
                                // aria-expanded="false"
                                // aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                  color: "white",
                                  minWidth: "100px",
                                  //  display :"none"
                                }}
                                onClick={() => {
                                  dispatch(
                                    VRcontentReducer.addContent_IsPane1(true)
                                  );
                                  // handleReset();
                                  // setFormvalues([]);
                                  // setadd3DContentfiles(false);
                                  // setadd3DContent(false);
                                }}
                              >
                                &nbsp;
                                <span
                                  className="ToolTipU"
                                  style={{
                                    backgroundColor: "var(--themes-color)",
                                  }}
                                >
                                  <i className="bi bi-view-list"></i>&nbsp; View
                                  VR_Content
                                  <span
                                    className="ToolTipTextU"
                                    style={{
                                      backgroundColor:
                                        View_Permission === 1
                                          ? "var(--themes-color)"
                                          : "red",
                                    }}
                                  >
                                    {View_Permission === 1
                                      ? "You can view the VR_Content."
                                      : "You cannot view the VR_Content."}
                                  </span>
                                </span>
                              </button>
                            )}
                            {showBy === "Application" && (
                              <button
                                className="btn"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                  color: "white",
                                  minWidth: "100px",
                                  display: "none",
                                }}
                                onClick={() => {
                                  dispatch(
                                    VRcontentReducer.addContent_IsPane1(true)
                                  );
                                  handleReset();
                                  setFormvalues([]);
                                  setadd3DContentfiles(false);
                                  setadd3DContent(false);
                                }}
                              >
                                &nbsp;
                                <span
                                  className="ToolTipU"
                                  style={{
                                    backgroundColor: "var(--themes-color)",
                                  }}
                                >
                                  <i className="bi bi-view-list"></i>&nbsp; View
                                  VR_Content
                                  <span
                                    className="ToolTipTextU"
                                    style={{
                                      backgroundColor:
                                        View_Permission === 1
                                          ? "var(--themes-color)"
                                          : "red",
                                    }}
                                  >
                                    {View_Permission === 1
                                      ? "You can view the VR_Content."
                                      : "You cannot view the VR_Content."}
                                  </span>
                                </span>
                              </button>
                            )}
                          </div>

                          <div className="p-2">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "100px",
                              }}
                              onClick={() => {
                                if (Add_Permission === 1) {
                                  dispatch(
                                    VRcontentReducer.addContent_IsPane(true)
                                  );
                                  handleReset();
                                  setFormvalues([]);
                                }
                              }}
                            >
                              <span
                                className="ToolTipU"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                VR_Content
                                <span
                                  className="ToolTipTextU"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add a VR_Content."
                                    : "You cannot add a VR_Content."}
                                </span>
                              </span>
                            </button>
                          </div>
                          <div className="dropdown p-2">
                            {content_filterVR ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "80px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  dispatch(
                                    VRcontentReducer.content_filterVR(false)
                                  );
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{ backgroundColor: "white" }}
                                onClick={() => {
                                  //dispatch(VRcontentReducer.content_filterVR(true));
                                  handleReset();

                                  // setTableHeight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                          <div className="p-2 dropdown">
                            <div
                              className="ps-1 py-2 pe-0"
                              // type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              style={
                                viewCards ? null : { visibility: "hidden" }
                              }
                            >
                              <strong style={{ cursor: "pointer" }}>
                                {showBy}
                              </strong>
                              <span className="ps-1 pt-3">
                                <i className="bi bi-caret-down-fill"></i>
                              </span>
                            </div>
                            <ul className="dropdown-menu">
                              <li
                                className="dropdown-item py-1"
                                onClick={() => setShowBy("Application")}
                                style={{ cursor: "pointer" }}
                              >
                                Application
                              </li>

                              {/* <li
                                className="dropdown-item py-1"
                                onClick={() => setShowBy("Product")}
                                style={{ cursor: "pointer" }}
                              >
                                Product
                              </li> */}
                              <li
                                className="dropdown-item py-1"
                                onClick={() => setShowBy("All content")}
                                style={{ cursor: "pointer" }}
                              >
                                All Content
                              </li>
                            </ul>
                          </div>
                          <div className="p-2">
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Typography
                                sx={
                                  !viewCards
                                    ? { fontWeight: "bold", scale: "1.2" }
                                    : null
                                }
                              >
                                Table
                              </Typography>
                              <Switch
                                checked={viewCards}
                                onChange={() => {
                                  setViewCards(!viewCards);
                                  setShowBy("All content");
                                }}
                                // color="var(--themes-color)"
                                // color="red"
                                inputProps={{ "aria-label": "controlled" }}
                              />
                              <Typography
                                sx={
                                  viewCards
                                    ? { fontWeight: "bold", scale: "1.2" }
                                    : null
                                }
                              >
                                Cards
                              </Typography>
                            </Stack>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0" style={{height:"100%"}}>
                <div className="col">
                  <div className="Image container-fluid g-0" style={{height:"100%"}}>
                    {!content_IsPane &&
                      !addcontent_IsPane &&
                      !addcontent_IsPane1 && (
                        <div className="accordion" id="accordionExample">
                          {/* <div className="accordion-item"> */}
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div
                              className="accordion-body d-flex align-items-end p-2 "
                              style={{
                                backgroundColor: "#E3F7F9",
                                height: "90px",
                              }}
                            >
                              <div className="d-flex flex-row justify-content-between ">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 2 },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        width: "20ch",
                                        zIndex: "0",
                                      },
                                    }}
                                    value={ContentFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setContentFilter(val);
                                      // setDummyContentFilter(val);
                                    }}
                                  />
                                  <FormControl sx={{ width: "20ch" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={ContentselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setContentselData(val);
                                        setDummyContentselData(val);
                                      }}
                                    >
                                      {showBy !== "Application" ? (
                                        <MenuItem value="te_contentname">
                                          Content Name
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Application" ? (
                                        <MenuItem value="te_contenttag">
                                          Content Tag
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Application" ? (
                                        <MenuItem value="te_contenttype">
                                          Content Type
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Application" ? (
                                        <MenuItem value="te_contentfilename">
                                          Content filename
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Application" ? (
                                        <MenuItem value="te_contentformat">
                                          Content format
                                        </MenuItem>
                                      ) : null}
                                      {showBy !== "Application" ? (
                                        <MenuItem value="te_contentdescription">
                                          Content description
                                        </MenuItem>
                                      ) : null}
                                      <MenuItem value="te_buname">
                                        Business Unit
                                      </MenuItem>
                                      <MenuItem value="te_divisionname">
                                        Division
                                      </MenuItem>
                                      <MenuItem value="te_application_name">
                                        Application
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>

                                <div
                                  className="d-flex flex-row justify-content-around g-0"
                                  style={{ marginLeft: "-25px" }}
                                >
                                  <button
                                    className="btn text-white mx-4"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "85px",
                                      position: "relative",
                                      top: "17px",
                                      right: "-30px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(
                                        e,
                                        ContentselData,
                                        ContentFilter
                                      );
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      ContentFilter.length > 0 &&
                                      ContentFilter.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "85px",
                                      position: "relative",
                                      top: "17px",
                                      left: "40px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                    }}
                                    disabled={
                                      ContentFilter.length > 0 &&
                                      ContentFilter.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                      )}
                    {!viewCards && (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ height: "80vh" }}
                      >
                        {!apiLoad ? (
                          <div>
                            <table
                              // className="table table-hoverborder-top-0 table-wrapper-scroll-y my-custom-scrollbar"
                              className="table table-hover ListUserTable ListContentTable border-top-0"
                              ref={ref}
                              style={{ overflowX: "auto" }}
                            >
                              <thead style={{ backgroundColor: "#ecedef" }}>
                                <tr style={{ textAlign: "left" }} e="true">
                                  <th className="border">Content Name</th>
                                  <th className="border">Content Tag</th>
                                  <th className="border">Content Type</th>
                                  <th className="border">Content Filename</th>
                                  <th className="border">Content Format</th>
                                  <th className="border">
                                    Content Description
                                  </th>
                                  <th className="border">Application Name</th>
                                  <th className="border">BusinessUnit</th>
                                  <th className="border">Division Name</th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: "left" }}>
                                {contentData.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan={9}
                                      className=" border text-center mb-0"
                                    >
                                      NO DATA FOUND
                                    </td>
                                  </tr>
                                ) : (
                                  contentData.map((item, index) => (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: `${
                                          item.te_contentid === content_id &&
                                          content_IsPane === true
                                            ? " #f2f3f5"
                                            : " #fff"
                                        }`,
                                      }}
                                      onClick={() => {
                                        viewContentFunction(item);
                                      }}
                                    >
                                      <td className="border text-start">
                                        {item.Content3DType === "false"
                                          ? item.te_contentname
                                          : item.te_filename}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_contenttag}
                                      </td>
                                      <td className="border text-start">
                                        {item.Content3DType === "false"
                                          ? item.te_contenttype
                                          : "3D content"}
                                      </td>
                                      <td className="border text-start">
                                        {item.Content3DType === "false"
                                          ? item.te_contentfilename
                                          : item.te_filename}
                                      </td>
                                      <td className="border text-start">
                                        {item.Content3DType === "false"
                                          ? item.te_contentformat
                                          : "NA"}
                                      </td>
                                      <td className="border text-start">
                                        {item.Content3DType === "false"
                                          ? item.te_contentdescription
                                          : "NA"}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_application_name}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_buname}
                                      </td>
                                      <td className="border text-start">
                                        {item.te_divisionname}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                            <div style={{ height: "100px" }}></div>
                          </div>
                        ) : (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        )}
                      </div>
                    )}
                    {viewCards && showBy === "All content" && (
                      <div>
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <div className="ContentCardMain d-flex flex-wrap">
                            {contentData.length === 0 ? (
                              <h6
                                style={{
                                  marginLeft: "500px",
                                  marginTop: "10px",
                                }}
                              >
                                No Data Found{" "}
                              </h6>
                            ) : (
                              contentData.map((item, index) => {
                                return item ? (
                                  <div
                                    className="ms-5 mt-5"
                                    key={index}
                                    onClick={() => {
                                      viewContentFunction(item);
                                    }}
                                  >
                                    <div
                                      className={`card border shadow-sm mb-3 content${
                                        item.te_contenttype === "video"
                                          ? "Video"
                                          : item.te_contenttype === "image"
                                          ? "Image"
                                          : item.te_contenttype === "audio"
                                          ? "Audio"
                                          : item.te_contenttype === "file"
                                          ? "File"
                                          : item.te_threedcontenturl !== " "
                                          ? "ThreeD"
                                          : item.te_contenttype === "text"
                                          ? "Text"
                                          : null
                                      }`}
                                      style={{
                                        height: "250px",
                                        borderRadius: "0px",
                                        maxWidth: "245px",
                                        minWidth: "245px",
                                      }}
                                    >
                                      <div className="top"></div>
                                      <div
                                        className="logoContent"
                                        style={{ borderRadius: "25px" }}
                                      >
                                        <img
                                          style={{
                                            height: "50px",
                                            width: "50px",
                                            // borderRadius: "25px",
                                          }}
                                          src={
                                            item.te_contentformat === "png"
                                              ? require("../../images/png1.png")
                                              : item.te_contentformat === "jpg"
                                              ? require("../../images/jpg1.png")
                                              : item.te_contentformat === "pdf"
                                              ? require("../../images/pdf1.png")
                                              : item.te_contentformat === "gif"
                                              ? require("../../images/gif1.png")
                                              : item.te_contentformat === "jpeg"
                                              ? require("../../images/jpeg1.png")
                                              : item.te_contentformat === "mp4"
                                              ? require("../../images/mp41.png")
                                              : item.te_contentformat === "txt"
                                              ? require("../../images/txt1.png")
                                              : item.te_contentformat === "mp3"
                                              ? require("../../images/mp31.png")
                                              : item.te_contentformat === "docx"
                                              ? require("../../images/doc1.png")
                                              : item.te_contentformat === "mov"
                                              ? require("../../images/mov.png")
                                              : item.te_threedcontenturl !== " "
                                              ? require("../../images/3dlogo.png")
                                              : null
                                          }
                                          alt="C_LOGO"
                                        />
                                      </div>
                                      <p
                                        className="pt-4 mt-1 ps-2 m-0"
                                        style={{ fontSize: "1rem" }}
                                      >
                                        {/* {item.te_contentname} */}

                                        {item.Content3DType === "false"
                                          ? item.te_contentname
                                          : item.te_filename}
                                      </p>
                                      <p
                                        className="ps-2 m-0"
                                        style={{ fontSize: "0.8rem" }}
                                      >
                                        {item.te_buname} /{" "}
                                        {item.te_divisionname}
                                      </p>
                                      <p className="ps-2 mb-0">
                                        {item.Content3DType === "false"
                                          ? item.te_contentformat
                                          : "NA"}
                                      </p>

                                      {item.te_contentstatus === "1" &&
                                        item.Content3DType === "false" && (
                                          <div
                                            className="rounded-start text-center text-white"
                                            style={{
                                              position: "absolute",
                                              width: "80px",
                                              backgroundColor: "rgb(58,201,53)",
                                              top: "8px",
                                              right: "0px",
                                              height: "20px",
                                            }}
                                          >
                                            <span
                                              className=""
                                              style={{
                                                fontSize: "14px",
                                                position: "relative",
                                                top: "-2px",
                                              }}
                                            >
                                              Active
                                            </span>
                                          </div>
                                        )}
                                      {item.te_contentstatus === "0" &&
                                        item.Content3DType === "false" && (
                                          <div
                                            className="rounded-start text-center text-white"
                                            style={{
                                              position: "absolute",
                                              width: "80px",
                                              backgroundColor: "rgb(201,53,53)",
                                              top: "8px",
                                              right: "0px",
                                              height: "20px",
                                            }}
                                          >
                                            <span
                                              className=""
                                              style={{
                                                fontSize: "14px",
                                                position: "relative",
                                                top: "-2px",
                                              }}
                                            >
                                              InActive
                                            </span>
                                          </div>
                                        )}
                                      {item.te_3dcontentstatus === "1" &&
                                        item.Content3DType === "true" && (
                                          <div
                                            className="rounded-start text-center text-white"
                                            style={{
                                              position: "absolute",
                                              width: "80px",
                                              backgroundColor: "rgb(58,201,53)",
                                              top: "8px",
                                              right: "0px",
                                              height: "20px",
                                            }}
                                          >
                                            <span
                                              className=""
                                              style={{
                                                fontSize: "14px",
                                                position: "relative",
                                                top: "-2px",
                                              }}
                                            >
                                              Active
                                            </span>
                                          </div>
                                        )}
                                      {item.te_3dcontentstatus === "0" &&
                                        item.Content3DType === "true" && (
                                          <div
                                            className="rounded-start text-center text-white"
                                            style={{
                                              position: "absolute",
                                              width: "80px",
                                              backgroundColor: "rgb(201,53,53)",
                                              top: "8px",
                                              right: "0px",
                                              height: "20px",
                                            }}
                                          >
                                            <span
                                              className=""
                                              style={{
                                                fontSize: "14px",
                                                position: "relative",
                                                top: "-2px",
                                              }}
                                            >
                                              InActive
                                            </span>
                                          </div>
                                        )}

                                      <hr
                                        className="m-0"
                                        style={{
                                          marginTop: "2px",
                                          marginBottom: "2px",
                                        }}
                                      />
                                      <div className="card-body pt-2 ps-1">
                                        <p
                                          className="g-0"
                                          style={{
                                            maxWidth: "90%",
                                            minWidth: "89%",
                                            maxHeight: "10px",
                                            fontSize: "11px",
                                          }}
                                        >
                                          {item.Content3DType === "false"
                                            ? item.te_contentdescription
                                            : "NA"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null;
                              })
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {viewCards && showBy === "Application" && (
                      <div style={{ height: "95vh", overflowY: "auto" }}>
                        {ApplicationResponse.map((item, index) => (
                          <ApplicationAccordion
                            parentItem={item}
                            key={index}
                            tableupdate={tableupdate}
                          />
                        ))}
                        <div style={{ height: "150px" }}></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/** ROW 3 for pagenation ! it should not visible when popup are there */}
            </div>

            {/* pagination footer */}
            {!apiLoad && (
              <div className="container">
                <div className="row main-footer">
                  <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                    Total Records: {contentCount}
                  </div>
                  <div className="col-4 mt-2">
                    <div className="d-flex justify-content-center ">
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            leftEndArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== 1 && leftArrow();
                          }}
                        ></i>
                      </div>
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index1_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index1_pagenation,
                            ContentselData,
                            ContentFilter
                          );
                        }}
                      >
                        {index1_pagenation}
                      </div>
                      {noOfPages > 1 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index2_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index2_pagenation,
                              ContentselData,
                              ContentFilter
                            );
                          }}
                        >
                          {index2_pagenation}
                        </div>
                      )}
                      {noOfPages > 2 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index3_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index3_pagenation,
                              ContentselData,
                              ContentFilter
                            );
                          }}
                        >
                          {index3_pagenation}
                        </div>
                      )}
                      {noOfPages > 3 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index4_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index4_pagenation,
                              ContentselData,
                              ContentFilter
                            );
                          }}
                        >
                          {index4_pagenation}
                        </div>
                      )}
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== noOfPages && rightArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            rightEndArrow();
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 mt-2 ">
                    <div className="d-flex justify-content-end me-3">
                      <span>
                        <strong>Page {pageSelected} </strong> of{" "}
                        <strong>{noOfPages}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/** SlidingPan pop up for Viewing content data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="75%"
            hideHeader
            isOpen={addcontent_IsPane1}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              // onCancel();
            }}
          >
            <div className="container-fluid " style={{ height: "100%" }}>
              <div
                className="row p-0 align-items-center border "
                style={{
                  height: "6%",
                  backgroundColor: "#e6f2f7",
                  paddingBottom: "0px !important",
                  borderColor: "#e6f2f7 !important",
                }}
              >
                <div className="col-3 ">
                  <div className="d-flex align-items-center flex-row">
                    <div
                      className="px-2 my-1"
                      onClick={() => {
                        dispatch(sidebarReducer.stringUpdate("ListContentVR"));
                        resetAddContent1();
                        setcolvisible(false);
                        // setcol1visible(false);
                        dispatch(VRcontentReducer.col1_visible(false));
                        setaddExtra(false);
                        setadd3DContentfiles(false);
                      }}
                    >
                      <i className="bi bi-arrow-right"></i>
                    </div>
                    {/* px-2 pt-2 pb-1 */}
                    <div className=" border-secondary border-opacity-25 border-start">
                      <h5>
                        <strong className="ms-3">View VR_Content</strong>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-9"></div>
              </div>
              {/* first row */}
              <div
                className="row pt-1"
                style={{
                  paddingBottom: "0px",
                  backgroundColor: "#e6f2f7",
                  // backgroundColor: "red",

                  // height: "9%",
                }}
              >
                <div className="col">
                  <div className="p-2">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                        {/* {bu_viewcontent} */}
                        {showBy === "Application"
                          ? bu_viewcontent
                          : "Business Unit"}
                        {/* { EbuName.length > 0 ? EbuName : "Business Unit"} */}
                      </InputLabel>
                      <Select
                        labelId="bu-label"
                        label="Business Unit"
                        size="small"
                        variant="outlined"
                        required
                        disabled={failDisable}
                        // value = {bu_viewcontent}
                        onChange={(e) => {
                          dispatch(VRcontentReducer.division_edit(true));
                          let val = e.target.value;
                          DivData(val);
                          fetchApplicationID(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                        {/* {division_viewcontent} */}
                        {showBy === "Application"
                          ? division_viewcontent
                          : "Division"}
                        {/* {EDivName.length > 0 ? EDivName : "Division"} */}
                      </InputLabel>
                      <Select
                        labelId="bu-label"
                        size="small"
                        variant="outlined"
                        label="Division"
                        onChange={(e) => {
                          dispatch(VRcontentReducer.product_edit(true));
                          let val = e.target.value;
                          // console.log("div name", val);
                          fetchApplicationID(val);
                        }}
                        disabled={
                          !failDisable ? (division_edit ? false : true) : true
                        }
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem key={index} value={item.te_divisionid}>
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        {/* {product_viewcontent} */}
                        {showBy === "Application"
                          ? product_viewcontent
                          : "Applications"}
                        {/* {EproductName.length > 0 ? EproductName : "Product"} */}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Applications"
                        variant="outlined"
                        size="small"
                        onChange={async (e) => {
                          let val = e.target.value;
                          setShowhide1(val);
                          setApplicationID(val);
                          setShowhide1(showhide1);
                          // setcol1visible(true);
                          dispatch(VRcontentReducer.col1_visible(true));

                          tableupdate(val);
                          // tableupdate(product_viewcontent);
                        }}
                        disabled={
                          !failDisable ? (product_edit ? false : true) : true
                        }
                      >
                        {applicationData.map((item, index) => (
                          <MenuItem key={index} value={item.te_application_id}>
                            {item.te_application_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>

              <div
                className="row shadow"
                style={{
                  backgroundColor: "#e6f2f7",
                  height: "3vh",
                }}
              ></div>

              <div
                className="row"
                style={{
                  height: "63%",
                  overflowY: "auto",
                  position: "fixed",
                  width: "100%",
                  // bottom: "0px",
                }}
              ></div>

              <div
                className="row "
                style={{
                  height: "70vh",
                  overflowY: "auto",
                  position: "fixed",
                  width: "100%",

                  // bottom: "0px",
                }}
              >
                <div
                  className="col g-0"
                  style={{
                    // backgroundColor: "#E6F2F7",
                    marginBottom: "30px",
                  }}
                >
                  {content_btn ? (
                    <table
                      // stickyHeader
                      className="table table-hover border-top-0 mb-2"
                      ref={ref}
                      style={{
                        overflowX: "auto",
                      }}
                    >
                      <thead
                        className="border-bottom border-secondary shadow"
                        style={{
                          backgroundColor: "#E6F2F7",
                          position: "sticky",
                          top: "0px",
                        }}
                      >
                        <tr style={{ textAlign: "left" }} e="true">
                          <th className="border">Content Name</th>
                          <th className="border">Content Tag</th>
                          <th className="border">Content Filename</th>
                          <th className="border">Content Description</th>
                          <th className="border">Content Type</th>
                          <th className="border">Content Format</th>
                          <th className="border">Actions</th>
                        </tr>
                      </thead>
                      <tbody
                        style={{
                          textAlign: "left",
                          backgroundColor: "#fff",
                          borderCollapse: "separate",
                          borderSpacing: "0 15px",
                        }}
                      >
                        {contentData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={9}
                              className=" border text-center mb-0"
                            >
                              NO DATA FOUND
                            </td>
                          </tr>
                        ) : (
                          viewContentTable.map((item, index) => {
                            return (
                              <tr
                                key={index}
                                style={{
                                  cursor: "pointer",
                                  // backgroundColor: `${
                                  //   item.te_isdeleted === "0"
                                  //     ? " #ffffff"
                                  //     : "rgb(195, 198, 205)"
                                  // }`,
                                  backgroundColor: "#ffffff",
                                }}
                              >
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    viewContentFunction(item);
                                  }}
                                >
                                  <img
                                    style={{
                                      height: "20px",
                                      width: "20px",
                                      // borderRadius: "25px",
                                    }}
                                    src={
                                      item.te_contentformat === "png"
                                        ? require("../../images/png1.png")
                                        : item.te_contentformat === "jpg"
                                        ? require("../../images/jpg1.png")
                                        : item.te_contentformat === "pdf"
                                        ? require("../../images/pdf1.png")
                                        : item.te_contentformat === "gif"
                                        ? require("../../images/gif1.png")
                                        : item.te_contentformat === "jpeg"
                                        ? require("../../images/jpeg1.png")
                                        : item.te_contentformat === "mp4"
                                        ? require("../../images/mp41.png")
                                        : item.te_contentformat === "txt"
                                        ? require("../../images/txt1.png")
                                        : item.te_contentformat === "docx"
                                        ? require("../../images/doc1.png")
                                        : item.te_contentformat === "mp3"
                                        ? require("../../images/mp31.png")
                                        : item.te_contentformat === "mov"
                                        ? require("../../images/mov.png")
                                        : item.te_threedcontenturl !== " "
                                        ? require("../../images/3dlogo.png")
                                        : null
                                    }
                                    alt="C_LOGO"
                                  />
                                  &nbsp;&nbsp;
                                  {item.Content3DType === "false"
                                    ? item.te_contentname
                                    : item.te_filename}
                                </td>
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    viewContentFunction(item);
                                  }}
                                >
                                  {item.te_contenttag}
                                </td>
                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    viewContentFunction(item);
                                  }}
                                >
                                  {item.Content3DType === "false"
                                    ? item.te_contentfilename
                                    : item.te_filename}
                                </td>

                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    viewContentFunction(item);
                                  }}
                                >
                                  {item.Content3DType === "false"
                                    ? item.te_contentdescription
                                    : "NA"}
                                </td>

                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    viewContentFunction(item);
                                  }}
                                >
                                  {item.Content3DType === "false"
                                    ? item.te_contenttype
                                    : "3D Content"}
                                </td>

                                <td
                                  className="border text-start"
                                  onClick={() => {
                                    viewContentFunction(item);
                                  }}
                                >
                                  {item.Content3DType === "false"
                                    ? item.te_contentformat
                                    : "NA"}
                                </td>

                                <td className="border text-start">
                                  <i
                                    className="bi bi-pencil-square"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      item.Content3DType === "false"
                                        ? onEdit(item)
                                        : on3DEdit(item);
                                      item.Content3DType === "false"
                                        ? seteditPopUp(true)
                                        : setedit3DPopUp(true);
                                    }}
                                  ></i>
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  <i
                                    className="bi bi-archive-fill"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setdeletepopUp(true);

                                      let funA = () => {
                                        setEcontentID(item.te_contentid);
                                        setEcontentDeleteType("Content");
                                      };

                                      let funB = () => {
                                        setEcontentID(item.te_3dmodelcontentid);
                                        setEcontentDeleteType("3DContent");
                                      };

                                      item.Content3DType === "false"
                                        ? funA()
                                        : funB();
                                    }}
                                  ></i>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
          </SlidingPane>
          ;{/** SlidingPan pop up for add content data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="75%"
            hideHeader
            isOpen={addcontent_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              //  onCancel();
            }}
          >
            <div className="container-fluid " style={{ height: "100%" }}>
              <div
                className="row p-0 align-items-center border"
                style={{ height: "8%", backgroundColor: "#e6f2f7" }}
              >
                <div className="col-3">
                  <div className="d-flex align-items-center flex-row">
                    <div
                      className="px-2 my-1"
                      onClick={() => {
                        dispatch(sidebarReducer.stringUpdate("ListContentVR"));
                        resetAddContent();
                        setcolvisible(false);
                        // setcol1visible(false);

                        dispatch(VRcontentReducer.col1_visible(false));
                      }}
                    >
                      <i className="bi bi-arrow-right"></i>
                    </div>
                    <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                      <h5>
                        <strong>Add VR_Content</strong>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-9"></div>
              </div>
              {/* first row */}
              <div
                className="row "
                style={{
                  paddingBottom: "0px",
                  backgroundColor: "#e6f2f7",
                }}
              >
                <div className="col">
                  <div className="p-2">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                        Business Unit
                        {/* {EbuName.length > 0 ? EbuName : "Business Unit"} */}
                      </InputLabel>
                      <Select
                        labelId="bu-label"
                        label="Business Unit"
                        size="small"
                        variant="outlined"
                        required
                        disabled={failDisable}
                        onChange={(e) => {
                          dispatch(VRcontentReducer.division_edit(true));

                          let val = e.target.value;
                          DivData(val);
                          fetchApplicationID(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="bu-label" size="small">
                        Division
                        {/* {EDivName.length > 0 ? EDivName : "Division"} */}
                      </InputLabel>
                      <Select
                        labelId="bu-label"
                        size="small"
                        variant="outlined"
                        label="Division"
                        onChange={(e) => {
                          dispatch(VRcontentReducer.product_edit(true));
                          let val = e.target.value;
                          fetchApplicationID(val);
                        }}
                        disabled={
                          !failDisable ? (division_edit ? false : true) : true
                        }
                      >
                        {divisionData.map((item, index) => (
                          <MenuItem key={index} value={item.te_divisionid}>
                            {item.te_divisionname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="p-2 ">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label" size="small">
                        Application
                        {/* {EproductName.length > 0 ? EproductName : "Product"} */}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Application"
                        variant="outlined"
                        size="small"
                        onChange={(e) => {
                          let val = e.target.value;
                          setShowhide1(val);
                          setApplicationID(val);

                          dispatch(VRcontentReducer.content_btn(true));
                        }}
                        disabled={
                          !failDisable ? (product_edit ? false : true) : true
                        }
                      >
                        {applicationData.map((item, index) => (
                          <MenuItem key={index} value={item.te_application_id}>
                            {item.te_application_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="col" style={{ paddingLeft: "0px" }}>
                  <div className="d-flex flex-row mt-2">
                    {/* <div className="p-0">
                      <Checkbox
                        {...label}
                        id="addExtra"
                        value={addExtra}
                        disabled={
                          !failDisable ? (content_btn ? false : true) : true
                        }
                        onChange={(e) => {
                          setcolvisible(true);
                          setaddExtra(e.target.checked);
                        }}
                      />
                    </div>

                    <div className="p-2">
                      <label className="form-check-label" htmlFor="addExtra">
                        <strong style={{ whiteSpace: "nowrap" }}>
                          <span>3D Content</span>
                        </strong>
                      </label>
                    </div>
                    <div className="p-2" style={{ whiteSpace: "nowrap" }}>
                      {api3DStatus === "L" && <div className="spinnerC"></div>}

                      {api3DStatus === "S" && (
                        <div style={{ color: "green" }}>
                          Added Successfully!
                        </div>
                      )}

                      {api3DStatus === "FNE" && (
                        <div style={{ color: "var(--themes-color)" }}>
                          File name already existed!
                        </div>
                      )}

                      {api3DStatus === "PE" && (
                        <div style={{ color: "var(--themes-color)" }}>
                          File already existed!
                        </div>
                      )}

                      {api3DStatus === "F" && (
                        <div style={{ color: "red" }}>Adding Failed!</div>
                      )}
                    </div> */}
                  </div>
                </div>
                <div className="col"></div>
                <div className="col " style={{ paddingRight: "5px" }}>
                  <div
                    className="p-0 "
                    style={{
                      textAlign: "center",
                      minWidth: "60px",
                    }}
                  >
                    <button
                      className="btn  text-white mt-1"
                      style={{
                        backgroundColor: "var(--themes-color)",
                      }}
                      // disabled={
                      //   !failDisable ? (content_btn ? false : true) : true
                      // }
                      onClick={() => {
                        addFormFields();
                      }}
                    >
                      Add Content
                    </button>
                  </div>
                </div>
              </div>
              {colvisible ? (
                <div
                  className="row border-bottom shadow "
                  style={{
                    paddingBottom: "0px",
                    minWidth: "77px",
                    backgroundColor: "#e6f2f7",
                    height: "62px",
                  }}
                >
                  <div className="col">
                    <div className="p-2">
                      {addExtra ? (
                        <ul style={{ paddingLeft: "0px" }}>
                          {addExtra && (
                            <input
                              type="file"
                              className="form-control"
                              id="formGroupExampleInput"
                              style={{ width: "99%" }}
                              placeholder="contentName"
                              disabled={failDisable}
                              onChange={(e) => {
                                change3DFile(e);
                              }}
                            />
                          )}
                          {threeDcorrectFile && (
                            <div className="pt-2 text-danger">
                              *Upload the correct file.
                            </div>
                          )}
                        </ul>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="col" style={{ paddingLeft: "0px" }}>
                    <div
                      className=" mt-2"
                      style={{ paddingLeft: "0px!important" }}
                    >
                      {addExtra ? (
                        <ul style={{ paddingLeft: "2px" }}>
                          {addExtra && (
                            <TextField
                              id="outlined-basic"
                              label="File Name"
                              variant="outlined"
                              fullWidth
                              size="small"
                              disabled={failDisable}
                              //value={EcontentFileName}
                              // disabled={content_edit ? false : true}
                              onChange={(e) => {
                                let val = e.target.value;
                                setFile3DName(val);
                                setEcontentFileName(val);
                              }}
                            />
                          )}
                        </ul>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="col" style={{ paddingLeft: "0px" }}>
                    <div className="p-2 ">
                      {addExtra ? (
                        <FormControl
                          sx={{
                            width: "98%",
                          }}
                        >
                          <InputLabel id="Content-Status" size="small">
                            osType
                          </InputLabel>
                          <Select
                            labelId="Content-Status"
                            id="demo-simple-select"
                            label="Inactiv"
                            size="small"
                            variant="outlined"
                            disabled={failDisable}
                            // value={EcontentStatus}
                            // disabled={content_edit ? false : true}
                            onChange={(e) => {
                              let val = e.target.value;
                              setOsType(val);
                              setEcontentStatus(val);
                            }}
                          >
                            <MenuItem value="ios">IoS</MenuItem>
                            <MenuItem value="android">Android</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              {/* second row */}
              {/* Paper component */}
              <div
                className="row"
                style={{
                  height: "63%",
                  overflowY: "auto",
                  position: "fixed",
                  width: "100%",
                  // bottom: "0px",
                }}
              >
                <div className="col mb-3">
                  <form style={{ margin: "0 auto" }}>
                    {formValues.map((data, i) => (
                      <div className="form-inline  " key={i}>
                        <Paper className="m-3 " elevation={3}>
                          <div
                            className="d-flex mb-2 justify-content-between"
                            style={{ height: "63%" }}
                          >
                            <div className="ms-2 mt-2">New</div>

                            <div className="">
                              <div className="d-flex">
                                <div className="p-2">
                                  {content1Arr[i] === "L" && (
                                    <div className="spinnerC"></div>
                                  )}
                                  {content1Arr[i] === "S" && (
                                    <div style={{ color: "green" }}>
                                      Added Successfully!
                                    </div>
                                  )}
                                  {content1Arr[i] === "FNE" && (
                                    <div
                                      style={{
                                        color: "var(--themes-color)",
                                      }}
                                    >
                                      File name already existed!
                                    </div>
                                  )}
                                  {content1Arr[i] === "FE" && (
                                    <div
                                      style={{
                                        color: "var(--themes-color)",
                                      }}
                                    >
                                      File already existed!
                                    </div>
                                  )}
                                  {content1Arr[i] === "F" && (
                                    <div style={{ color: "red" }}>
                                      Adding Failed!
                                    </div>
                                  )}
                                </div>
                                <div className="p-2">
                                  {i || i === 0 ? (
                                    <span
                                      onClick={(e) => {
                                        if (!failDisable) {
                                          removeFormFields(i);
                                          setdub(dub);
                                          setdub((num) => num - 1);
                                        }
                                      }}
                                    >
                                      <i className="bi bi-x-circle"></i>
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 1st row */}
                          <div className="row ">
                            <div className="col ms-2">
                              <div className="col">
                                <TextField
                                  variant="outlined"
                                  type="text"
                                  name="tag"
                                  label="Content Tag No:"
                                  fullWidth
                                  size="small"
                                  required
                                  value={CTag[i]}
                                  disabled={failDisable}
                                  onChange={(e) => {
                                    formValues[i].set(
                                      "teContentTag",
                                      e.target.value
                                    );
                                    CTag[i] = e.target.value;
                                    handleChangeTrial(i, e);
                                    // setContentTag(e.target.value);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col me-2">
                              {formValues[i].get("teContentType") ===
                              "3d_content" ? (
                                <TextField
                                  id="outlined-basic"
                                  label="File Name"
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={failDisable}
                                  value={TDCFileName[i]}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    formValues[i].set("teContentFileName", val);
                                    TDCFileName[i] = e.target.value;
                                    setFile3DName(val);
                                    setEcontentFileName(val);
                                  }}
                                />
                              ) : (
                                <TextField
                                  type="text"
                                  variant="outlined"
                                  name="name"
                                  label="Content Name:"
                                  fullWidth
                                  size="small"
                                  required
                                  value={CName[i]}
                                  disabled={failDisable}
                                  onChange={(e) => {
                                    formValues[i].set(
                                      "teContentName",
                                      e.target.value
                                    );
                                    CName[i] = e.target.value;

                                    handleChangeTrial(i, e);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                          {/* 2nd row */}
                          <div className="row mt-2 ">
                            <div className="col ms-2 ">
                              <div className="d-flex justify-content-between">
                                <div className="col ">
                                  <FormControl
                                    sx={{
                                      width: "70%",
                                    }}
                                    h
                                  >
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      size="small"
                                      required
                                    >
                                      Content Type
                                    </InputLabel>

                                    <Select
                                      labelId="demo-simple-select-filled-label"
                                      id="demo-simple-select-filled"
                                      name="cType"
                                      size="small"
                                      label="Content Type"
                                      variant="outlined"
                                      value={CType[i]}
                                      disabled={failDisable}
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        formValues[i].set(
                                          "teContentType",
                                          e.target.value
                                        );
                                        if (val === "text") {
                                          formValues[i].set(
                                            "teContentFormat",
                                            "txt"
                                          );
                                        }
                                        CType[i] = e.target.value;
                                        CMin[i] = "";
                                        CSec[i] = "";
                                        fileRurl[i] = "";
                                        if (val !== "3d_content") {
                                          formValues[i].delete(
                                            "teContentFileName"
                                          );
                                          formValues[i].delete("file");
                                          formValues[i].delete("ostype");
                                        } else {
                                          formValues[i].delete("teContentName");
                                          formValues[i].delete(
                                            "teContentDescription"
                                          );
                                          formValues[i].delete(
                                            "teContentFormat"
                                          );
                                        }
                                        handleMapping(val);
                                        handleChangeTrial(i, e);
                                      }}
                                    >
                                      <MenuItem
                                        value="image"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = img;
                                          }
                                          showhide[i] = false;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Image
                                      </MenuItem>
                                      <MenuItem
                                        value="audio"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = aud;
                                          }
                                          showhide[i] = true;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Audio
                                      </MenuItem>
                                      <MenuItem
                                        value="video"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = vid;
                                          }
                                          showhide[i] = true;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Video
                                      </MenuItem>
                                      <MenuItem
                                        value="file"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = docs;
                                          }
                                          showhide[i] = false;
                                          settextvalidated(false);
                                        }}
                                      >
                                        Doc
                                      </MenuItem>
                                      <MenuItem
                                        value="text"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = [];
                                          }
                                          showhide[i] = "text";
                                          settextvalidated(true);
                                        }}
                                      >
                                        Text
                                      </MenuItem>
                                      <MenuItem
                                        value="3d_content"
                                        onClick={() => {
                                          if (i < formValues.length) {
                                            fileType[i] = [];
                                          }
                                          showhide[i] = "text";
                                          settextvalidated(true);
                                        }}
                                      >
                                        3D Content
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                                <div className="col mt-0">
                                  <div className="d-flex justify-content-between">
                                    <div className="p-0 mt-2 ">
                                      <h6
                                        style={{
                                          color: "#a4a4a4",
                                          marginRight: "10px",
                                          marginTop: "2px",
                                        }}
                                      >
                                        Duration
                                      </h6>
                                    </div>
                                    <div className="p-0">
                                      <TextField
                                        id="filled-hidden-label-small"
                                        variant="outlined"
                                        label="Min"
                                        type="number"
                                        size="small"
                                        value={CMin[i]}
                                        disabled={
                                          failDisable
                                            ? true
                                            : showhide[i] === true
                                            ? false
                                            : true
                                        }
                                        inputProps={{
                                          max: 300,
                                          min: 0,
                                          step: 1,

                                          style: {
                                            textAlign: "center",
                                          },
                                        }}
                                        InputLabelProps={
                                          {
                                            // shrink: true,
                                          }
                                        }
                                        onChange={(e) => {
                                          // setminduration(e.target.value);
                                          formValues[i].set(
                                            "teContentmin",
                                            e.target.value
                                          );
                                          CMin[i] = e.target.value;
                                          handleChangeTrial(i, e);
                                        }}
                                      />
                                    </div>
                                    <span className="mt-2">&nbsp;:&nbsp;</span>
                                    <div className="p-0">
                                      <TextField
                                        id="filled-hidden-label-small"
                                        label="Sec"
                                        type="number"
                                        size="small"
                                        inputProps={{
                                          max: 59,
                                          min: 0,
                                          step: 1,
                                          style: {
                                            textAlign: "center",
                                          },
                                        }}
                                        value={CSec[i]}
                                        disabled={
                                          failDisable
                                            ? true
                                            : showhide[i] === true
                                            ? false
                                            : true
                                        }
                                        onChange={(e) => {
                                          // setsecduration(e.target.value);
                                          formValues[i].set(
                                            "teContentsec",
                                            e.target.value
                                          );
                                          CSec[i] = e.target.value;
                                          handleChangeTrial(i, e);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="col me-2"
                              onMouseEnter={() => setMapper(fileType[i])}
                            >
                              {CType[i] === "3d_content" ? (
                                <FormControl fullWidth>
                                  <InputLabel id="Content-Status" size="small">
                                    osType
                                  </InputLabel>
                                  <Select
                                    labelId="Content-Status"
                                    id="demo-simple-select"
                                    label="Inactiv"
                                    size="small"
                                    variant="outlined"
                                    disabled={failDisable}
                                    value={TDCosType[i]}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      formValues[i].set("ostype", val);
                                      TDCosType[i] = val;
                                      setOsType(val);
                                      setEcontentStatus(val);
                                    }}
                                  >
                                    {/* <MenuItem value="ios">IoS</MenuItem> */}
                                    <MenuItem value="android">Android</MenuItem>
                                    <MenuItem value="windows">Windows</MenuItem>
                                    <MenuItem value="NA">NA</MenuItem>
                                  </Select>
                                </FormControl>
                              ) : (
                                <FormControl fullWidth>
                                  <InputLabel id="content-format" size="small">
                                    File Format
                                  </InputLabel>
                                  <Select
                                    labelId="content-format"
                                    id="demo-simple-select"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      width: "100%",
                                    }}
                                    name="cForm"
                                    label="File Format"
                                    disabled={
                                      failDisable
                                        ? true
                                        : showhide[i] === "text"
                                        ? true
                                        : false
                                    }
                                    value={CFormat[i]}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setContentForm(contentForm);
                                      setContentForm(val);
                                      formValues[i].set(
                                        "teContentFormat",
                                        e.target.value
                                      );
                                      CFormat[i] = e.target.value;

                                      handleChangeTrial(i, e);
                                      let str = `.${e.target.value}`;
                                      setAccept(str);
                                      if (formValues.length === i) {
                                        setAcceprArr((arr) => [...arr, str]);
                                      } else if (i < formValues.length) {
                                        acceptArr[i] = str;
                                      }
                                    }}
                                  >
                                    <MenuItem selected value="">
                                      select format
                                    </MenuItem>
                                    {fileType.length > 0 &&
                                      fileType[i].map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                          {item}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              )}
                            </div>
                          </div>
                          {/* 3rd row */}

                          {/* {inter} */}
                          <div className="row mt-2 ">
                            <div className="col ms-2">
                              {CType[i] === "3d_content" ? (
                                <span>
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="formGroupExampleInput"
                                    placeholder="contentName"
                                    disabled={failDisable}
                                    onChange={(e) => {
                                      formValues[i].set(
                                        "file",
                                        e.target.files[0]
                                      );
                                      // change3DFile(e);
                                    }}
                                  />
                                  {/* <span className="pt-2 ps-2 text-danger">
                                    *Upload the correct file.
                                  </span> */}
                                </span>
                              ) : (
                                <TextField
                                  id="outlined-multiline-flexible"
                                  label="Content Description"
                                  multiline
                                  // maxRows={4}
                                  disabled={failDisable}
                                  rows={2}
                                  rowsMax={10}
                                  variant="outlined"
                                  name="Desc"
                                  required
                                  fullWidth
                                  size="small"
                                  value={CDescription[i]}
                                  onChange={(e) => {
                                    formValues[i].set(
                                      "teContentDescription",
                                      e.target.value
                                    );
                                    CDescription[i] = e.target.value;
                                    let val = e.target.value;
                                    setContentDesc(contentDesc);
                                    setContentDesc(val);
                                    handleChangeTrial(i, e);
                                  }}
                                />
                              )}
                            </div>

                            <div className="col me-2 ">
                              <FormControl fullWidth>
                                <InputLabel
                                  id="demo-simple-select-label"
                                  size="small"
                                  required
                                >
                                  Status
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-filled-label"
                                  id="demo-simple-select-filled"
                                  label="select status"
                                  name="status"
                                  variant="outlined"
                                  size="small"
                                  disabled={failDisable}
                                  value={CStatus[i]}
                                  onChange={(e) => {
                                    formValues[i].set(
                                      "teContentStatus",
                                      e.target.value
                                    );
                                    CStatus[i] = e.target.value;

                                    setdub((num) => num + 1);

                                    // setContentStatus(val);
                                    // handleChangeTrial(i, e);
                                  }}
                                >
                                  <MenuItem value="1">Active</MenuItem>
                                  <MenuItem value="0">InActive</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          {/* 4rth */}

                          {/* 6th row */}

                          <div className="row">
                            <div className="col ms-2 mt-0">
                              {CType[i] === "text" && (
                                <div className="row">
                                  <div className="col ">
                                    <TextField
                                      id="outlined-multiline-flexible"
                                      label="Enter Text"
                                      multiline
                                      // maxRows={4}
                                      rows={2}
                                      rowsMax={10}
                                      variant="outlined"
                                      name="text"
                                      fullWidth
                                      size="small"
                                      value={CText[i]}
                                      disabled={
                                        failDisable
                                          ? true
                                          : textvalidated
                                          ? false
                                          : true
                                      }
                                      onChange={(e) => {
                                        formValues[i].set(
                                          "teContentText",
                                          e.target.value
                                        );

                                        let val = e.target.value;
                                        CText[i] = val;

                                        settextvalidated(val);
                                        handleChangeTrial(i, e);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              {(CType[i] === "image" ||
                                CType[i] === "audio" ||
                                CType[i] === "video" ||
                                CType[i] === "file") && (
                                <div className=" row ms-2 mt-0 ">
                                  {/* <div className="col-3"> */}
                                  <FormControl>
                                    <RadioGroup
                                      row
                                      aria-labelledby="demo-row-radio-buttons-group-label"
                                      name="row-radio-buttons-group"
                                    >
                                      <FormControlLabel
                                        control={<Radio />}
                                        label="URL"
                                        Checked={
                                          fileRurl[i] === "URL" ? true : false
                                        }
                                        value="URL"
                                        name="urlOrFile"
                                        disabled={failDisable}
                                        onChange={(e) => {
                                          if (i < formValues.length) {
                                            fileRurl[i] = e.target.value;
                                          } //formValues[i].append("teContenttext",e.target.value);
                                          formValues[i].set(
                                            "teContentFileName",
                                            "url_file_name"
                                          );
                                          formValues[i].delete("content");
                                          handleChangeTrial(i, e);
                                          // setisfileformat(true);
                                        }}
                                      />
                                      <FormControlLabel
                                        control={<Radio />}
                                        label="File"
                                        id="file"
                                        name="urlOrFile"
                                        Checked={
                                          fileRurl[i] === "File" ? true : false
                                        }
                                        disabled={failDisable}
                                        // ref={fileRef}
                                        // checked={data.urlOrFile === "File"}
                                        onChange={(e) => {
                                          if (i < formValues.length) {
                                            fileRurl[i] = e.target.value;
                                          }
                                          handleChangeTrial(i, e);
                                          // setisfileformat(false);
                                        }}
                                        value="File"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </div>
                              )}

                              {/* </div> */}

                              <div></div>
                            </div>
                            <div
                              className="col me-2 "
                              // onMouseEnter={() => setMapper(fileType[i])}
                            >
                              {fileRurl[i] === "URL" && (
                                <TextField
                                  id="outlined-basic"
                                  style={{ marginTop: "5px" }}
                                  label="URL"
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  value={CUrl[i]}
                                  disabled={failDisable}
                                  onChange={(e) => {
                                    // let val = e.target.value;
                                    formValues[i].set(
                                      "teContentUrl",
                                      e.target.value
                                    );
                                    CUrl[i] = e.target.value;

                                    // setURLvalidated(val);
                                    handleChangeTrial(i, e);
                                  }}
                                />
                              )}
                              {fileRurl[i] === "File" && (
                                // showhide != "text" &&
                                <div
                                  onMouseEnter={() => setAccept(acceptArr[i])}
                                >
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="formGroupExampleInput"
                                    style={{ marginTop: "5px" }}
                                    placeholder="contentName"
                                    disabled={failDisable}
                                    accept={accept}
                                    onChange={(e) => {
                                      let val = e.target.files[0];
                                      formValues[i].set("content", val);
                                      formValues[i].set(
                                        "teContentFileName",
                                        val.name
                                      );
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </Paper>
                      </div>
                    ))}
                  </form>
                </div>
              </div>
              <div
                className="row"
                style={{
                  backgroundColor: "#E3E3E3",
                  position: "fixed",
                  bottom: "28px",
                  width: "100%",
                }}
              >
                <div className="d-flex justify content start">
                  {(formValues.length > 0 || addExtra === true) && (
                    <button
                      type="submit"
                      className="btn btn-light text-white mb-2 mt-0"
                      style={{
                        backgroundColor: "var(--themes-color)",
                      }}
                      onClick={(e) => {
                        failDisable ? resetAddContent() : onSubmit3D(e);
                      }}
                      disabled={threeDcorrectFile}
                    >
                      &nbsp;{failDisable ? "Close" : "Submit"}
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/* </div> */}
          </SlidingPane>
          ;
          <Modal
            open={popUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <div
                  style={{
                    overflowY: "auto",
                    // height: "80%",
                  }}
                >
                  <h6 className="text-success">{successMsg}</h6>
                  <h6 className="" style={{ color: "var(--themes-color)" }}>
                    {existMsg}
                  </h6>
                  <h6 className="text-danger">{failMsg}</h6>
                </div>
                <div className="pt-4 ">
                  <button
                    type="button"
                    className="btn text-white"
                    style={{
                      backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() =>
                      existCountState === 0 && failCountState === 0
                        ? resetAddContent()
                        : failAddCase()
                    }
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={editpopUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {Edit_Permission === 1 ? (
                <div>
                  <div className="d-flex align-items-center mb-2 justify-content-between">
                    <div>
                      <h5>
                        <strong
                          style={{
                            position: "absolute",
                            top: "5px",
                            left: "15px",
                          }}
                        >
                          Edit
                        </strong>
                      </h5>
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "15px",
                      }}
                    >
                      <span onClick={onCancel}>
                        <i className="bi bi-x-circle  "></i>
                      </span>
                    </div>
                  </div>
                  <center>
                    <div>
                      <Paper
                        elevation={3}
                        style={{
                          marginTop: "12px",
                        }}
                      >
                        <div className="row ">
                          <div className="col ms-2 ">
                            <div className="col mt-2">
                              <TextField
                                variant="outlined"
                                type="text"
                                name="tag"
                                label="Content Tag No:"
                                fullWidth
                                size="small"
                                // required
                                value={EcontentTag}
                                disabled={editdisable ? true : false}
                                onChange={(e) => {
                                  setEcontentTag(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col me-2 mt-2">
                            <TextField
                              type="text"
                              variant="outlined"
                              name="name"
                              label="Content Name:"
                              fullWidth
                              size="small"
                              disabled={editdisable ? true : false}
                              value={EcontentName}
                              onChange={(e) => {
                                setEcontentName(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mt-2 ">
                          <div className="col ms-2">
                            <TextField
                              id="outlined-multiline-flexible"
                              label="Content Description"
                              multiline
                              disabled={editdisable ? true : false}
                              rows={2}
                              rowsMax={10}
                              variant="outlined"
                              name="Desc"
                              fullWidth
                              size="small"
                              value={EcontentDesc}
                              onChange={(e) => {
                                setEcontentDesc(e.target.value);
                              }}
                            />
                          </div>

                          <div className="col me-2 ">
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Content Format
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                name="cType"
                                size="small"
                                label="Content format"
                                value={EcontentFormat}
                                variant="outlined"
                                disabled={editdisable ? false : true}
                                onChange={(e) => {
                                  let val = e.target.value;

                                  setEcontentFormat(val);
                                }}
                              >
                                <MenuItem value={EcontentFormat}>
                                  {EcontentFormat}
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className="row mt-2 ">
                          <div className="col ms-2">
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Content Type
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-filled-label"
                                id="demo-simple-select-filled"
                                name="cType"
                                size="small"
                                label="Content Type"
                                value={EcontentType}
                                variant="outlined"
                                disabled={editdisable ? false : true}
                                onChange={(e) => {
                                  let val = e.target.value;

                                  setEcontentType(val);
                                }}
                              >
                                <MenuItem value="image">Image</MenuItem>
                                <MenuItem value="audio">Audio</MenuItem>
                                <MenuItem value="video">Video</MenuItem>
                                <MenuItem value="file">Doc</MenuItem>
                                <MenuItem value="text">Text</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col me-2">
                            <FormControl fullWidth>
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Status
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="cStatus"
                                size="small"
                                label="Status"
                                value={EcontentStatus}
                                disabled={editdisable ? true : false}
                                variant="outlined"
                                onChange={(e) => {
                                  let val = e.target.value;
                                  setEcontentStatus(val);
                                }}
                              >
                                <MenuItem value="1">Active</MenuItem>
                                <MenuItem value="0">Inactive</MenuItem>
                              </Select>
                            </FormControl>
                            {/* <div className="col "> */}
                          </div>
                        </div>
                      </Paper>

                      <Grid className="mt-4">
                        <button
                          type="button"
                          className="btn text-white"
                          style={{
                            backgroundColor: "var(--themes-color)",
                            width: "100px",
                            position: "absolute",
                            top: "250px",
                            left: "170px",
                          }}
                          onClick={onCancel}
                        >
                          Cancel
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          className="btn text-white"
                          style={{
                            backgroundColor: "var(--themes-color)",
                            width: "128px",
                            position: "absolute",
                            top: "250px",
                          }}
                          onClick={() => {
                            // onUpdate(content_id);
                            seteditPopUp(false);
                            onUpdate(content_id);
                          }}
                        >
                          Save Changes
                        </button>
                      </Grid>
                    </div>
                  </center>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <center>
                    <div className="p-2">
                      <h6 className="text-danger">
                        You have no permission to edit this content.
                      </h6>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn text-white"
                        style={{
                          backgroundColor: "var(--themes-color)",
                          width: "100px",
                        }}
                        onClick={onCancel}
                      >
                        Close
                      </button>
                    </div>
                  </center>
                </div>
              )}
            </Box>
          </Modal>
          <Modal
            open={deletepopUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {Delete_Permission === 1 ? (
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div
                    style={{
                      overflowY: "auto",
                    }}
                  >
                    <h6>Are you sure you want to delete this Content?</h6>
                  </div>

                  <div className="pt-4">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        onDelete(EcontentID);
                      }}
                    >
                      Delete
                    </button>
                    &nbsp; &nbsp; &nbsp;
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        setdeletepopUp(false);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <center>
                    <div className="p-2">
                      <h6 className="text-danger">
                        You have no permission to delete this content.
                      </h6>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn text-white"
                        style={{
                          backgroundColor: "var(--themes-color)",
                          width: "90px",
                        }}
                        onClick={() => {
                          setdeletepopUp(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </center>
                </div>
              )}
            </Box>
          </Modal>
          {/* View content page */}
          <Modal
            open={edit3DpopUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ padding: "15px !important" }}
          >
            <Box sx={style}>
              <center>
                <div className="d-flex mb-2 justify-content-between">
                  <div>
                    <h5>
                      <strong
                        style={{
                          position: "absolute",
                          top: "5px",
                          left: "15px",
                        }}
                      >
                        Edit
                      </strong>
                    </h5>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "15px",
                    }}
                  >
                    <span onClick={onCancel}>
                      <i className="bi bi-x-circle  "></i>
                    </span>
                  </div>
                </div>

                <div>
                  <Paper
                    elevation={3}
                    style={{
                      marginTop: "30px",
                    }}
                  >
                    <div className="row"></div>

                    <div
                      className="row "
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      <div className="col ms-2 mt-2">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label="File Name"
                          variant="outlined"
                          size="small"
                          // disabled={Edit3D ? false : true}
                          value={Econtent3Dfilename}
                          // disabled={content_edit ? false : true}
                          onChange={(e) => {
                            let val = e.target.value;
                            setEcontent3Dfilename(val);
                          }}
                        />
                      </div>
                      <div className="col me-2 mt-2">
                        <FormControl
                          fullWidth
                          sx={{
                            width: "97%",
                          }}
                          onChange={(e) => {
                            let val = e.target.value;
                            setOsType(val);
                            setEcontentStatus(val);
                          }}
                        >
                          <InputLabel id="Content-Status" size="small">
                            osType
                          </InputLabel>
                          <Select
                            labelId="Content-Status"
                            id="demo-simple-select"
                            label="Inactiv"
                            size="small"
                            variant="outlined"
                            // disabled={Edit3D ? false : true}
                            value={Econtent3DOs}
                            // value={EcontentStatus}
                            // disabled={content_edit ? false : true}
                            onChange={(e) => {
                              let val = e.target.value;
                              setEcontent3DOs(val);
                              setEcontentStatus(val);
                            }}
                          >
                            <MenuItem value="ios">IoS</MenuItem>
                            <MenuItem value="android">Android</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col me-2 ms-2">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          label="Content Tag"
                          variant="outlined"
                          size="small"
                          // disabled={Edit3D ? false : true}
                          value={Econtent3DTag}
                          // disabled={content_edit ? false : true}
                          onChange={(e) => {
                            let val = e.target.value;
                            setEcontent3DTag(val);
                          }}
                        />
                      </div>
                      <div className="col ">
                        <div className="col ">
                          <ul style={{ paddingLeft: "0px" }}>
                            <input
                              type="file"
                              className="form-control"
                              id="formGroupExampleInput"
                              style={{ width: "100%" }}
                              placeholder="contentName"
                              // disabled={failDisable}
                              onChange={(e) => {
                                change3DFile(e);
                              }}
                            />

                            {threeDcorrectFile && (
                              <div className="pt-2 text-danger">
                                *Upload the correct file.
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Paper>
                  <Grid className="mt-4">
                    <button
                      type="button"
                      className="btn text-white"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        width: "100px",
                        position: "absolute",
                        top: "232px",
                        left: "170px",
                      }}
                      onClick={onCancel}
                    >
                      Cancel
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn text-white"
                      style={{
                        backgroundColor: "var(--themes-color)",
                        width: "128px",
                        position: "absolute",
                        top: "232px",
                      }}
                      onClick={() => {
                        setedit3DPopUp(false);
                        on3DUpdate(content_3Did);
                      }}
                    >
                      Save Changes
                    </button>
                  </Grid>
                </div>
              </center>
            </Box>
          </Modal>
          <Modal
            open={viewContentPopUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box style={viewContentPopUpStyle}>
              <div
                className="d-flex justify-content-end"
                style={{ height: "50px" }}
              >
                <button
                  className="btn btn-danger m-1 p-2"
                  onClick={() => setViewContentPopUp(false)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div
                className="border m-2"
                style={{ height: "80vh", overflowY: "auto" }}
              >
                <div className="m-2">
                  {contentPopUpType === "image" && (
                    <div>
                      <h3 className="my-2 ps-2">
                        <strong>
                          {viewContentPopUpDetails.Content3DType === "false"
                            ? viewContentPopUpDetails.te_contentname
                            : viewContentPopUpDetails.te_filename}
                          {/* {viewContentPopUpDetails.te_contentname} */}
                        </strong>
                      </h3>
                      <div className="d-flex">
                        <div className="p-2">
                          <img
                            src={contentPopUpSrc}
                            alt={defaultUrl}
                            height="600px"
                            width="800px"
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <div className="p-2">
                          <div className="my-4">
                            <ul className="viewContentLi">
                              <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_application_name}`}</li>
                              <li className="my-3">
                                {viewContentPopUpDetails.te_contentdescription}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {contentPopUpType === "video" && (
                    <div>
                      <h3 className="my-2 ps-2">
                        <strong>
                          {viewContentPopUpDetails.te_contentname}
                        </strong>
                      </h3>
                      <div className="d-flex">
                        <div className="p-2">
                          <video
                            className="border"
                            controls
                            width="900"
                            height="450"
                          >
                            <source
                              src={contentPopUpSrc}
                              // type={`video/${contentPopUpFormat}`}
                            />
                            Sorry, your browser doesn't support videos.
                          </video>
                        </div>
                        <div className="p-2 ">
                          <div className="my-2">
                            <ul className="viewContentLi">
                              <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_application_name}`}</li>
                              <li className="my-3">
                                {viewContentPopUpDetails.te_contentdescription}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {contentPopUpType === "audio" && (
                    <div
                      style={{
                        height: "80vh",
                        paddingLeft: "43%",
                      }}
                    >
                      <div
                        className="ms-3"
                        style={{ paddingTop: "5%", marginBottom: "2%" }}
                      >
                        <h3>
                          <strong>
                            {viewContentPopUpDetails.te_contentname}
                          </strong>
                        </h3>
                      </div>
                      <audio controls controlsList="nodownload">
                        <source
                          src={contentPopUpSrc}
                          type={`audio/${contentPopUpFormat}`}
                        />
                        Your browser does not support the audio element.
                      </audio>
                      <div className="my-4">
                        <ul className="viewContentLi">
                          <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                          <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                          <li className="my-3">{`${viewContentPopUpDetails.te_application_name}`}</li>
                          <li className="my-3">
                            {viewContentPopUpDetails.te_contentdescription}
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {contentPopUpType === "text" && (
                    <div
                      className="p-2 shadow-sm"
                      style={{ height: "300px", overflow: "auto" }}
                    >
                      {contentPopUpSrc}
                    </div>
                  )}
                  {contentPopUpType === "file" &&
                    (contentPopUpFormat === "pdf" ? (
                      <div onContextMenu="return false">
                        <h3 className="my-3 ps-2">
                          <strong>
                            {viewContentPopUpDetails.te_contentname}
                          </strong>
                        </h3>
                        <div className="d-flex">
                          <div
                            className="audio-player p-2"
                            style={{ width: "70%" }}
                          >
                            <embed
                              src={`${contentPopUpSrc}#toolbar=0`}
                              type={`application/${contentPopUpFormat}`}
                              style={{ height: "70vh", width: "100%" }}
                            ></embed>{" "}
                          </div>
                          <div className="p-2">
                            <div className="my-4">
                              <ul className="viewContentLi">
                                <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li>
                                <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                                <li className="my-3">{`${viewContentPopUpDetails.te_application_name}`}</li>
                                <li className="my-3">
                                  {
                                    viewContentPopUpDetails.te_contentdescription
                                  }
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : contentPopUpFormat === "txt" ? (
                      <embed
                        src={contentPopUpSrc}
                        type="text/plane"
                        style={{ width: "100%", height: "80vh" }}
                      ></embed>
                    ) : contentPopUpFormat === "doc" ? (
                      <embed
                        src={contentPopUpSrc}
                        type="application/msword"
                        style={{ width: "100%", height: "80vh" }}
                      ></embed>
                    ) : contentPopUpFormat === "docx" ? (
                      <embed
                        src={contentPopUpSrc}
                        type="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        style={{ width: "100%", height: "80vh" }}
                      ></embed>
                    ) : contentPopUpFormat === "odt" ? (
                      <embed
                        src={contentPopUpSrc}
                        type="application/vnd.oasis.opendocument.text"
                        style={{ width: "100%", height: "80vh" }}
                      ></embed>
                    ) : null)}
                  {viewContentPopUpDetails.Content3DType === "true" && (
                    <div>
                      <h3 className="my-2 ps-5">
                        <strong>{viewContentPopUpDetails.te_filename}</strong>
                      </h3>
                      <div className="d-flex">
                        <div className="p-2">
                          {/* <img
                            src={contentPopUpSrc}
                            alt={defaultUrl}
                            height="800px"
                            width="800px"
                          /> */}
                        </div>
                        <div className="p-2">
                          <div className="my-4">
                            <ul className="viewContentLi">
                              {/* <li className="my-3">{`${viewContentPopUpDetails.te_contentformat} format`}</li> */}
                              <li className="my-3">{`${viewContentPopUpDetails.te_buname} / ${viewContentPopUpDetails.te_divisionname}`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_application_name}`}</li>
                              <li className="my-3">{`${viewContentPopUpDetails.te_threedcontenturl}`}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Modal>
          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListContent;
